import { render, staticRenderFns } from "./listItem.vue?vue&type=template&id=5b5bd123&scoped=true"
import script from "./listItem.vue?vue&type=script&lang=ts"
export * from "./listItem.vue?vue&type=script&lang=ts"
import style0 from "./listItem.vue?vue&type=style&index=0&id=5b5bd123&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5bd123",
  null
  
)

export default component.exports